import type { ReactNode } from "react";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar.tsx";
import { SimpleThemeToggle } from "@/components/ui/simple-theme-toggle.tsx";
import { useDarkMode } from "@/hooks/use-dark-mode.tsx";
import { AppSidebar } from "@/salesminer/layouts/app/sidebar/app-sidebar.tsx";

const PageHeader = () => {
  const { theme, toggle } = useDarkMode();

  return (
    <header className="flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12">
      <div className="flex items-center justify-between w-full gap-2 px-4">
        <div className="flex items-center gap-2">
          <SidebarTrigger className="-ml-1" />
        </div>
        <SimpleThemeToggle theme={theme} onCycle={toggle} />
      </div>
    </header>
  );
};

interface AppLayoutProps {
  children: ReactNode;
}

export default function SalesminerAppLayout({ children }: AppLayoutProps) {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <PageHeader />
        <div className="flex flex-1 flex-col gap-4 p-4 pt-0">
          <div className="bg-muted/50 min-h-[100vh] flex-1 rounded-xl md:min-h-min">
            <div className="p-4 lg:p-6">{children}</div>
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
